import CardCommon from '@op/components/CardCommon';
import { barIcon, lineIcon, stackLineIcon, tableIcon } from '@op/constants/chart';
import React, { useMemo, useState } from 'react';
import './index.scss';
import Table from './Table';
import Chart from './Chart';
import { formatDateFunc } from '@op/utils/time';
import useLanguage from '@op/hooks/useLanguage';
import { useRealtimeOverviewMetricsChart } from '../../hook';
import SortBySelect from '@op/components/FilterBoxCommon/filters/single-select-factory';
import { downloadAction } from '@op/pages/download/utils';
import _ from 'lodash-es';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
export default function MentionsChart(props: any) {
  const { gameInfo, filter, type, height = 366, maxHeight = 345.5, tabType, dropdown, metrics, formatValue, needRadar: needRadarProps, data: propsData, byType, setByType, loading, ...restProps } = props;
  const { formatMessage } = useLanguage();
  const [chartType, setChartType] = useState('stack_line');

  const { metricsKey, needRadar, restOpt } = useMemo(() => {
    if (dropdown) {
      const { metrics: metricsKey, needRadar, ...restOpt } = dropdown.find((val) => val.value === byType);
      return {
        metricsKey,
        needRadar,
        restOpt
      };
    }
    return {
      metricsKey: metrics,
      needRadar: needRadarProps,
      restOpt: restProps
    };
  }, [dropdown, byType, metrics]);


  const { data } = useRealtimeOverviewMetricsChart({
    filter,
    data: propsData,
    extraData: {
      metricsKey,
      ...restOpt
    }
  });

  const { chartData, tableData, isEmpty } = useMemo(() => {
    const { tableData, isEmpty, ...restData } = data;
    return {
      chartData: restData,
      tableData,
      isEmpty
    };
  }, [data]);

  const columns = useMemo(() => {
    const { title, showTotal } = restOpt;
    const filtered = _.clone(metricsKey) || [];
    if (showTotal && !filtered.some(item => item.value === 'total')) {
      filtered.unshift({
        name: title || 'Total',
        value: 'total',
      });
    }
    return filtered;
  }, [metricsKey]);


  const operations = useMemo(() => {
    const ops = [tableIcon, lineIcon, stackLineIcon];
    // 5分钟粒度不展示柱状图
    if (tabType !== 'real_time_total_5_minute') {
      ops.push(barIcon);
    }
    return ops;
  }, [tabType]);

  return (
    <CardCommon
      contentCard
      operationInfo={[chartType, setChartType]}
      operations={operations}
      hasDownload={!isEmpty}
      empty={isEmpty}
      className='dbo-realtime-mentions-chart-wrapper'
      loading={loading}
      loadingHeight={height + 30}
      emptyHeight={height + 30}
      title={(
        <>
          {dropdown && (
            <div className="realtime-header">
              <SortBySelect
                defaultValue={byType}
                onChange={(key: string, value: any) => {
                  buriedBtnPoint('RO_OverviewMetrics_Dropdown', value);
                  setByType(value);
                }}
                defaultParams={{
                  options: dropdown,
                  btnTextPrefix: formatMessage({ id: 'Metrics' }),
                  matchButtonWidth: true,

                  // dealwithButton: (value: any, { textMap }: any) => {
                  //   return textMap[value];
                  // },
                }}
              />
            </div>
          )}
        </>
      )}
      handleDownloadOnClick={() => {
        downloadAction({
          key: 'RealtimeOverviewMetricsDownload',
          fileName: `Realtime Overview Metrics`,
          filter: {
            ...filter,
            ...gameInfo,
          },
          auxiliaryParams: {
            columns
          },
          data: tableData
        });
      }}
      logBtnId="RO_OverviewMetrics"
      extraInfo={{ metrics, tabType, type, byType }}
    >
      {chartType === 'table' ? (
        <Table
          data={tableData}
          columns={columns}
          formatTimeFunc={formatDateFunc(filter?.date_type || 'hourly')}
          maxHeight={maxHeight}
          {...restOpt}
        />
      ) : (
        <Chart
          chartType={chartType}
          data={chartData}
          metrics={metricsKey}
          filter={filter}
          formatDate={formatDateFunc(filter?.date_type || 'hourly')}
          formatValue={formatValue}
          needRadar={needRadar}
          height={height}
          isAccumulated={tabType === 'real_time_total_5_minute'}
          showTooltipLink={tabType !== 'discuss_players'}
          {...restOpt}
        />
      )}
    </CardCommon>
  );
}